import type { FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "sipli-fleet-core/components";
import AdditionalInformation from "./tabs/AdditionalInformation";
import InterfaceDetails from "./tabs/InterfaceDetails";
import InvoiceSettings from "./tabs/InvoiceSettings";
import MainInformation from "./tabs/MainInformation";

interface CustomerTabsProps {
  form: FormInstance;
  activeKey: string;
  setActiveKey: (key: string) => void;
  selectLookups: CustomerSelectLookups;
}

export interface CustomerSelectOption {
  label: string;
  value: string | number;
}

export interface CustomerSelectLookups {
  clientPresetOptions: CustomerSelectOption[];
  clientTypeOptions: CustomerSelectOption[];
  clientStatusOptions: CustomerSelectOption[];
  languageOptions: CustomerSelectOption[];
  countryOptions: CustomerSelectOption[];
  customerCountryOptions: CustomerSelectOption[];
  currencyOptions: CustomerSelectOption[];
  distanceOptions: CustomerSelectOption[];
  volumeOptions: CustomerSelectOption[];
  temperatureOptions: CustomerSelectOption[];
  weightOptions: CustomerSelectOption[];
  fuelOptions: CustomerSelectOption[];
  positionOptions: CustomerSelectOption[];
  productOptions: CustomerSelectOption[];
  clientSourceOptions: CustomerSelectOption[];
  clientCompetitorOptions: CustomerSelectOption[];
  clientPositionTypeOptions: CustomerSelectOption[];
  vatOptions: CustomerSelectOption[];
  paymentTypeOptions: CustomerSelectOption[];
  paymentOptions: CustomerSelectOption[];
  paymentSubsUnitOptions: CustomerSelectOption[];
  pprPaymentTermOptions: CustomerSelectOption[];
  clientPresetLoading: boolean;
  clientTypeLoading: boolean;
  clientStatusLoading: boolean;
  languageLoading: boolean;
  countryLoading: boolean;
  customerCountryLoading: boolean;
  currencyLoading: boolean;
  distanceLoading: boolean;
  volumeLoading: boolean;
  temperatureLoading: boolean;
  weightLoading: boolean;
  fuelLoading: boolean;
  positionLoading: boolean;
  productLoading: boolean;
  clientSourceLoading: boolean;
  clientCompetitorLoading: boolean;
  clientPositionTypeLoading: boolean;
  paymentTypeLoading: boolean;
  paymentLoading: boolean;
  paymentSubsUnitLoading: boolean;
  pprPaymentTermLoading: boolean;
}

const CustomerTabs = ({
  form,
  activeKey,
  setActiveKey,
  selectLookups,
}: CustomerTabsProps) => {
  const { t } = useTranslation();

  const tabItems = [
    {
      key: "main_information",
      label: t("main_information"),
      children: <MainInformation form={form} selectLookups={selectLookups} />,
      forceRender: true,
    },
    {
      key: "additional_information",
      label: t("additional_information"),
      children: (
        <AdditionalInformation form={form} selectLookups={selectLookups} />
      ),
      forceRender: true,
    },
    {
      key: "invoice_settings",
      label: t("invoice_settings"),
      children: <InvoiceSettings form={form} selectLookups={selectLookups} />,
      forceRender: true,
    },
    {
      key: "interface_details",
      label: t("interface_details"),
      children: <InterfaceDetails form={form} selectLookups={selectLookups} />,
      forceRender: true,
    },
  ];

  return (
    <CustomTabs
      tabPosition="left"
      className="custom-tabs-customers !mt-3"
      items={tabItems}
      onChange={setActiveKey}
      activeKey={activeKey}
      destroyOnHidden={false}
    />
  );
};

export default CustomerTabs;
